var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeLens
    ? _c("div", { staticClass: "viq-lens-indicator" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "14",
              height: "14",
              viewBox: "0 0 14 14",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M7 1L9 5.5L14 6.5L10.5 10L11.5 14L7 12L2.5 14L3.5 10L0 6.5L5 5.5L7 1Z",
                fill: "currentColor",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "viq-lens-indicator__name" }, [
          _vm._v("Lens: " + _vm._s(_vm.activeLens.name)),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "viq-lens-indicator__clear",
            attrs: { title: "Clear lens" },
            on: { click: _vm.clearLens },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "10",
                  height: "10",
                  viewBox: "0 0 10 10",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M2 2l6 6M8 2l-6 6",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                  },
                }),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }